import Index from './pages/companies';
import React from 'react';

export function AuthenticatedApp() {
  return (
    <div className={'flex flex-col h-full'}>
      <Index />
    </div>
  );
}

export default AuthenticatedApp;
